export const config = {
  title: 'Angie Cornish of Keller Williams | Realtor',
  meta: {
    description:
      'Angie Cornish of Keller Williams is your trusted realtor in Kentucky, specializing in helping you find your dream home with personalized services and expert guidance.',
    keywords: [
      'MyBizSolutions',
      'Realtor in Kentucky',
      'Find Dream Home',
      'Real Estate Services',
      'Angie Cornish',
      'Keller Williams',
    ],
    author: 'Angie Cornish',
    canonicalUrl: 'https://mybizsolutions.us/',
  },
  sections: {
    header: {
      businessName: 'Angie Cornish | Realtor',
    },
    sectionB: {
      heroTitle: "Angie Cornish | Realtor",
      heroSubtitle: "Helping You Find Your Dream Home in Kentucky",
      learnAboutText: "Learn About",
      phoneNumber: "2706260419",
      phoneLabel: "(270) 625-0419",
      heroBackgroundImage:
        "https://www.spoliamag.com/wp-content/uploads/2021/07/pexels-curtis-adams-5178047-696x521.jpg",
      cardData: [
        {
          title: "Personalized Service",
          description:
          "Angie ensures a tailored approach that meets your unique needs, making every client feel like her top priority.",
        },
        {
          title: "Flexibility and Availability",
          description:
          "With a deep understanding of busy schedules, Angie accommodates your time, offering seamless scheduling for consultations.",
        },
        {
          title: "Expert Guidance",
          description:
          "With years of experience, Angie’s professional advice helps you buy your dream home or sell for top value.",
        },
      ],
      description:
      'Angie Cornish of Keller Williams provides comprehensive services to guide you in finding your dream home or selling your property for top value.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'At Keller Williams, we provide comprehensive services to guide you in finding your dream home or selling your property for top value.',
      cards: [
        {
          title: 'Property Listing',
          description:
          'Expertly crafted property listings to highlight your home’s best features and attract potential buyers.',
          imageSrc:
            'https://images.marketleader.com/HouseImages/CINCINNATI/517/1759517.jpg?PhotoAccessKey=cfaf15d78ea50c0c99cdb3d0d0b5336f',
            imageAlt: 'Property Listing',
          },
        {
          title: 'Commercial Real Estate',
          description:
          'Comprehensive support for buying and selling commercial properties in Kentucky.',
          imageSrc:
            'https://images.marketleader.com/HouseImages/CINCINNATI/489/1601489.jpg?PhotoAccessKey=cfaf15d78ea50c0c99cdb3d0d0b5336f',
            imageAlt: 'Commercial Real Estate Services',
          },
        {
          title: 'Lot Selling',
          description:
          'Specialized services to help you sell or buy vacant lots with confidence.',
          imageSrc:
            'https://media.istockphoto.com/id/1330299451/photo/highway-us-interstate-70-through-the-scioto-woods-columbus-ohio-usa-of-aerial-view.jpg?s=612x612&w=0&k=20&c=ftd43JZcC5laR84e1qWdZykQwm4t1lbHPsvrAjevzQo=',
            imageAlt: 'Lot Selling Services',
          },
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://images.marketleader.com/MarketingImages/97/2404197_normal.jpg',
        alt: 'Angie Cornish of Keller Williams | Realtor',
      },
      aboutText: [
        'Angie Cornish of Keller Williams is a dedicated realtor in Kentucky, offering expert guidance and personalized service to help clients achieve their real estate goals.',
        'With years of experience, Angie provides tailored solutions to make the buying or selling process seamless and stress-free.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'Angie Cornish Profile Image',
      businessName: 'Angie Cornish | Realtor',
      contact: {
        phone: '2706260419',
        phoneLabel: "(270) 625-0419",
        email: 'angiex109@gmail.com',
        website: 'https://www.angiecornishhomes.com/',
        address: '680 U.S. 62, Eddyville, KY 42038',
      },
      socialMedia: {
        googlePlus: null, // If null, falls back to https://mybizsolutions.us/
        linkedIn: null,
        facebook: null,
        twitter: null,
        tiktok: null, // If null, falls back to https://mybizsolutions.us/
        instagram: null,
        youtube: null,
      },
    },
    sectionF: {
      address: '680 U.S. 62, Eddyville, KY 42038',
      googleMapsEmbedUrl:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2887.5105881886655!2d-84.4164797844882!3d35.18192617918219!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x884039afdf85df3d%3A0x73dc541ee2fae5e0!2s680%20U.S.%2062%2C%20Eddyville%2C%20KY%2042038!5e0!3m2!1sen!2sph!4v1614123456789!5m2!1sen!2sph',
    },
  },
};

export default config;
